import HttpData from "@/http/data/http-data";

export interface IAccessControlDoorPasscodesData {
    passcodes: number[];
}

export default class AccessControlDoorPasscodesData extends HttpData {
    public passcodes: number[];

    constructor(data: IAccessControlDoorPasscodesData) {
        super();

        this.passcodes = data.passcodes;
    }
}
